module.exports = __webpack_public_path__ + "static/media/SV2.92933b66.jpg";